<script setup lang="ts">
import type { PlaceDetail } from '@consumer/types/serializers'

const {
  places,
  buttonGradient = 'linear-gradient(180deg, rgb(249 249 249 / 0%) 5.05%, #f9f9f9 39.55%)',
} = defineProps<{
  places: PlaceDetail[]
  buttonGradient?: string
}>()

const emit = defineEmits<{ click: [value: PlaceDetail] }>()

const viewAllOverlay = ref(places && places.length > 8)

const placesToShow = computed(() => places && viewAllOverlay.value
  ? places.slice(0, 8)
  : places)

</script>
<template>
  <div class="relative">
    <div class="grid grid-cols-2 gap-2">
      <div
        v-for="place in places"
        :key="place.id"
        data-testid="place"
        class="flex flex-row bg-white rounded-v2lg items-center gap-3 p-2 clickable"
        style=" border: 1px solid #e4eaf1;border-radius: 12px; box-shadow: 0 3px 8px 0 rgb(17 30 54 / 5%);"
        @click="emit('click', place)"
      >
        <img
          class="rounded-full border-2 border-solid border-white"
          style="box-shadow: 0 0.824px 0.824px 0 rgb(0 0 0 / 6%), 1.285px 1.285px 5.142px 0 rgb(0 0 0 / 10%);"
          :src="place.imageUrl"
          alt=""
          width="29"
          height="29"
        >
        <div class="flex flex-col items-start justify-items-center">
          <div class="text-sm font-semibold overflow-ellipsis">
            {{ place.name }}
          </div>
          <div
            v-if="place.categories && place.categories.length > 0"
            class="text-xs overflow-ellipsis text-v2-tertiary"
          >
            {{ place.categories[0] }}
          </div>

        </div>
      </div>
    </div>
    <div
      v-if="viewAllOverlay && placesToShow"
      class="absolute px-2 pt-8 pb-3 w-full"
      :style="{ background: buttonGradient, bottom: '-30px' }"
    >
      <GButton secondary size="medium" class="w-full" @click="viewAllOverlay = false">
        View all {{ placesToShow.length }} places
      </GButton>
    </div>
  </div>
</template>
